module.exports = __webpack_public_path__ + "static/media/wait.a91ddf46.png";